import { render } from "./VIP.vue?vue&type=template&id=1659a872&scoped=true"
import script from "./VIP.vue?vue&type=script&lang=js"
export * from "./VIP.vue?vue&type=script&lang=js"

import "./VIP.vue?vue&type=style&index=0&id=1659a872&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1659a872"]])

export default __exports__